
<div class="bubbleContainer">
  <v-btn class="helpButton" v-show="! display" @click="display = true">
    <v-icon>help_outline</v-icon>
    {{ $t('HELP_TITLE') }}
  </v-btn>
  <div class="speech-bubble" v-show="display">
    <v-icon class="hoverPointer closeIcon" @click="close()">close</v-icon>
    <p v-html="$t('HELP_TEXT')"></p>
  </div>
</div>

